export const EVENT_TEMPLATE_OWNERS = {
  DEFAULT: 'default',
  CLIENT: 'CL_',
};
